export const ACCEPTED_IMAGE_UPLOADS = ['png', 'jpeg'];
export const NOTIFICATION_DURATION = 4000;

export const DEFAULT_CONSOLE_LANGUAGE_CODE = 'en';
export const DEFAULT_CONTENT_LANGUAGE_CODE = 'en';
export const DEFAULT_CONSOLE_LANGUAGE = { code: DEFAULT_CONSOLE_LANGUAGE_CODE, label: 'English' };
export const DEFAULT_CONTENT_LANGUAGE = { code: DEFAULT_CONTENT_LANGUAGE_CODE, label: 'English' };
export const DEFAULT_LANGUAGE_READ_FROM = 'space';

export const LANGUAGE_READ = [
    {
        id: 'browser',
        name: 'browser',
    },
    {
        id: 'application',
        name: 'space settings',
    },
];

export const LOCALIZATION_SOURCE_OPTIONS = [
    {
        id: 'cookie',
        name: 'Cookie',
    },
    {
        id: 'localStorage',
        name: 'Local Storage',
    },
    {
        id: 'jsVariable',
        name: 'JavaScript Variable',
    },
    {
        id: 'cssPath',
        name: 'CSS Selector',
    },
    {
        id: 'urlQuery',
        name: 'URL Query',
    },
    {
        id: 'urlRegex',
        name: 'URL Regex',
    },
    {
        id: 'userProvided',
        name: 'User Provided',
    },
];

export const USER_ACCESS_RIGHTS = [
    {
        value: 'read',
        name: 'Read',
    },
    {
        value: 'write',
        name: 'Write',
    },
    {
        value: 'admin',
        name: 'Admin',
    },
];

export const MODEL_TYPE_CONFUSION = [
    {
        value: 'detection',
        name: 'Machine learning',
    },
    {
        value: 'heurestic',
        name: 'Heurestic',
    },
];

export const CONFUSION_REACTION_TYPES = {
    NONE: 'none',
    OPEN_CONFUSION_DIALOG: 'openConfusionDialog',
    SHAKE_CONTEXT_HELP: 'shakeContextHelp',
};

export const CONFUSION_REACTION = [
    {
        value: CONFUSION_REACTION_TYPES.NONE,
        id: 'Settings.confusion.reaction.none',
        defaultMessage: 'Do not act',
    },
    {
        value: CONFUSION_REACTION_TYPES.OPEN_CONFUSION_DIALOG,
        id: 'Settings.confusion.reaction.openConfusionDialog',
        defaultMessage: 'Help dialog',
    },
    {
        value: CONFUSION_REACTION_TYPES.SHAKE_CONTEXT_HELP,
        id: 'Settings.confusion.reaction.shakeContextHelp',
        defaultMessage: 'Shake context help',
    },
];

export const KIND_OF_USERS = [
    {
        value: 'userCollected',
        name: 'User Collected',
    },
    {
        value: 'systemCollected',
        name: 'System Collected',
    },
    {
        value: 'userFrontend',
        name: 'User Frontend',
    },
];

export const VALUE_OF_TYPES = [
    {
        value: 'keyword',
        name: 'Keyword',
    },
    {
        value: 'date',
        name: 'Date',
    },
    {
        value: 'integer',
        name: 'Integer',
    },
    {
        value: 'double',
        name: 'Double',
    },
    {
        value: 'boolean',
        name: 'Boolean',
    },
];

export const GUIDE_TYPES = {
    TOUR: 'tour',
    INTERACTION_COLLECTOR: 'c-overlay',
    ERROR_COLLECTOR: 'e-overlay',
    APPLICATION_AUGMENTATION: 'a-overlay',
};

export const BROWSERS = {
    CHROME: 'chrome',
    FIREFOX: 'firefox',
};

export const SUPPORTED_BROWSERS = [BROWSERS.CHROME, BROWSERS.FIREFOX];

export const BROWSERS_LINKS = {
    CHROME:
        'https://chrome.google.com/webstore/detail/custom-javascript-for-web/poakhlngfciodnhlhhgnaaelnpjljija',
    FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/custom-style-script/',
};

export const CONTEXT_HELP_LAUNCHER_POSITION = [
    {
        value: 'themePositioned',
        name: 'Theme positioned',
    },
    {
        value: 'attachedToElement',
        name: 'Attached to element',
    },
];

export const LIST_OF_COUNTRIES = [
    {
        name: 'Unknown countries',
        code: 'UNKNOWN_COUNTRY',
    },
    {
        name: 'All country',
        code: 'ALL_COUNTRY',
    },
    {
        name: 'Afghanistan',
        code: 'AF',
    },
    {
        name: 'Åland Islands',
        code: 'AX',
    },
    {
        name: 'Albania',
        code: 'AL',
    },
    {
        name: 'Algeria',
        code: 'DZ',
    },
    {
        name: 'American Samoa',
        code: 'AS',
    },
    {
        name: 'AndorrA',
        code: 'AD',
    },
    {
        name: 'Angola',
        code: 'AO',
    },
    {
        name: 'Anguilla',
        code: 'AI',
    },
    {
        name: 'Antarctica',
        code: 'AQ',
    },
    {
        name: 'Antigua and Barbuda',
        code: 'AG',
    },
    {
        name: 'Argentina',
        code: 'AR',
    },
    {
        name: 'Armenia',
        code: 'AM',
    },
    {
        name: 'Aruba',
        code: 'AW',
    },
    {
        name: 'Australia',
        code: 'AU',
    },
    {
        name: 'Austria',
        code: 'AT',
    },
    {
        name: 'Azerbaijan',
        code: 'AZ',
    },
    {
        name: 'Bahamas',
        code: 'BS',
    },
    {
        name: 'Bahrain',
        code: 'BH',
    },
    {
        name: 'Bangladesh',
        code: 'BD',
    },
    {
        name: 'Barbados',
        code: 'BB',
    },
    {
        name: 'Belarus',
        code: 'BY',
    },
    {
        name: 'Belgium',
        code: 'BE',
    },
    {
        name: 'Belize',
        code: 'BZ',
    },
    {
        name: 'Benin',
        code: 'BJ',
    },
    {
        name: 'Bermuda',
        code: 'BM',
    },
    {
        name: 'Bhutan',
        code: 'BT',
    },
    {
        name: 'Bolivia',
        code: 'BO',
    },
    {
        name: 'Bosnia and Herzegovina',
        code: 'BA',
    },
    {
        name: 'Botswana',
        code: 'BW',
    },
    {
        name: 'Bouvet Island',
        code: 'BV',
    },
    {
        name: 'Brazil',
        code: 'BR',
    },
    {
        name: 'British Indian Ocean Territory',
        code: 'IO',
    },
    {
        name: 'Brunei Darussalam',
        code: 'BN',
    },
    {
        name: 'Bulgaria',
        code: 'BG',
    },
    {
        name: 'Burkina Faso',
        code: 'BF',
    },
    {
        name: 'Burundi',
        code: 'BI',
    },
    {
        name: 'Cambodia',
        code: 'KH',
    },
    {
        name: 'Cameroon',
        code: 'CM',
    },
    {
        name: 'Canada',
        code: 'CA',
    },
    {
        name: 'Cape Verde',
        code: 'CV',
    },
    {
        name: 'Cayman Islands',
        code: 'KY',
    },
    {
        name: 'Central African Republic',
        code: 'CF',
    },
    {
        name: 'Chad',
        code: 'TD',
    },
    {
        name: 'Chile',
        code: 'CL',
    },
    {
        name: 'China',
        code: 'CN',
    },
    {
        name: 'Christmas Island',
        code: 'CX',
    },
    {
        name: 'Cocos (Keeling) Islands',
        code: 'CC',
    },
    {
        name: 'Colombia',
        code: 'CO',
    },
    {
        name: 'Comoros',
        code: 'KM',
    },
    {
        name: 'Congo',
        code: 'CG',
    },
    {
        name: 'Congo, The Democratic Republic of the',
        code: 'CD',
    },
    {
        name: 'Cook Islands',
        code: 'CK',
    },
    {
        name: 'Costa Rica',
        code: 'CR',
    },
    {
        name: "Cote D'Ivoire",
        code: 'CI',
    },
    {
        name: 'Croatia',
        code: 'HR',
    },
    {
        name: 'Cuba',
        code: 'CU',
    },
    {
        name: 'Cyprus',
        code: 'CY',
    },
    {
        name: 'Czech Republic',
        code: 'CZ',
    },
    {
        name: 'Denmark',
        code: 'DK',
    },
    {
        name: 'Djibouti',
        code: 'DJ',
    },
    {
        name: 'Dominica',
        code: 'DM',
    },
    {
        name: 'Dominican Republic',
        code: 'DO',
    },
    {
        name: 'Ecuador',
        code: 'EC',
    },
    {
        name: 'Egypt',
        code: 'EG',
    },
    {
        name: 'El Salvador',
        code: 'SV',
    },
    {
        name: 'Equatorial Guinea',
        code: 'GQ',
    },
    {
        name: 'Eritrea',
        code: 'ER',
    },
    {
        name: 'Estonia',
        code: 'EE',
    },
    {
        name: 'Ethiopia',
        code: 'ET',
    },
    {
        name: 'Falkland Islands (Malvinas)',
        code: 'FK',
    },
    {
        name: 'Faroe Islands',
        code: 'FO',
    },
    {
        name: 'Fiji',
        code: 'FJ',
    },
    {
        name: 'Finland',
        code: 'FI',
    },
    {
        name: 'France',
        code: 'FR',
    },
    {
        name: 'French Guiana',
        code: 'GF',
    },
    {
        name: 'French Polynesia',
        code: 'PF',
    },
    {
        name: 'French Southern Territories',
        code: 'TF',
    },
    {
        name: 'Gabon',
        code: 'GA',
    },
    {
        name: 'Gambia',
        code: 'GM',
    },
    {
        name: 'Georgia',
        code: 'GE',
    },
    {
        name: 'Germany',
        code: 'DE',
    },
    {
        name: 'Ghana',
        code: 'GH',
    },
    {
        name: 'Gibraltar',
        code: 'GI',
    },
    {
        name: 'Greece',
        code: 'GR',
    },
    {
        name: 'Greenland',
        code: 'GL',
    },
    {
        name: 'Grenada',
        code: 'GD',
    },
    {
        name: 'Guadeloupe',
        code: 'GP',
    },
    {
        name: 'Guam',
        code: 'GU',
    },
    {
        name: 'Guatemala',
        code: 'GT',
    },
    {
        name: 'Guernsey',
        code: 'GG',
    },
    {
        name: 'Guinea',
        code: 'GN',
    },
    {
        name: 'Guinea-Bissau',
        code: 'GW',
    },
    {
        name: 'Guyana',
        code: 'GY',
    },
    {
        name: 'Haiti',
        code: 'HT',
    },
    {
        name: 'Heard Island and Mcdonald Islands',
        code: 'HM',
    },
    {
        name: 'Holy See (Vatican City State)',
        code: 'VA',
    },
    {
        name: 'Honduras',
        code: 'HN',
    },
    {
        name: 'Hong Kong',
        code: 'HK',
    },
    {
        name: 'Hungary',
        code: 'HU',
    },
    {
        name: 'Iceland',
        code: 'IS',
    },
    {
        name: 'India',
        code: 'IN',
    },
    {
        name: 'Indonesia',
        code: 'ID',
    },
    {
        name: 'Iran, Islamic Republic Of',
        code: 'IR',
    },
    {
        name: 'Iraq',
        code: 'IQ',
    },
    {
        name: 'Ireland',
        code: 'IE',
    },
    {
        name: 'Isle of Man',
        code: 'IM',
    },
    {
        name: 'Israel',
        code: 'IL',
    },
    {
        name: 'Italy',
        code: 'IT',
    },
    {
        name: 'Jamaica',
        code: 'JM',
    },
    {
        name: 'Japan',
        code: 'JP',
    },
    {
        name: 'Jersey',
        code: 'JE',
    },
    {
        name: 'Jordan',
        code: 'JO',
    },
    {
        name: 'Kazakhstan',
        code: 'KZ',
    },
    {
        name: 'Kenya',
        code: 'KE',
    },
    {
        name: 'Kiribati',
        code: 'KI',
    },
    {
        name: "Korea, Democratic People'S Republic of",
        code: 'KP',
    },
    {
        name: 'Korea, Republic of',
        code: 'KR',
    },
    {
        name: 'Kuwait',
        code: 'KW',
    },
    {
        name: 'Kyrgyzstan',
        code: 'KG',
    },
    {
        name: "Lao People'S Democratic Republic",
        code: 'LA',
    },
    {
        name: 'Latvia',
        code: 'LV',
    },
    {
        name: 'Lebanon',
        code: 'LB',
    },
    {
        name: 'Lesotho',
        code: 'LS',
    },
    {
        name: 'Liberia',
        code: 'LR',
    },
    {
        name: 'Libyan Arab Jamahiriya',
        code: 'LY',
    },
    {
        name: 'Liechtenstein',
        code: 'LI',
    },
    {
        name: 'Lithuania',
        code: 'LT',
    },
    {
        name: 'Luxembourg',
        code: 'LU',
    },
    {
        name: 'Macao',
        code: 'MO',
    },
    {
        name: 'Macedonia, The Former Yugoslav Republic of',
        code: 'MK',
    },
    {
        name: 'Madagascar',
        code: 'MG',
    },
    {
        name: 'Malawi',
        code: 'MW',
    },
    {
        name: 'Malaysia',
        code: 'MY',
    },
    {
        name: 'Maldives',
        code: 'MV',
    },
    {
        name: 'Mali',
        code: 'ML',
    },
    {
        name: 'Malta',
        code: 'MT',
    },
    {
        name: 'Marshall Islands',
        code: 'MH',
    },
    {
        name: 'Martinique',
        code: 'MQ',
    },
    {
        name: 'Mauritania',
        code: 'MR',
    },
    {
        name: 'Mauritius',
        code: 'MU',
    },
    {
        name: 'Mayotte',
        code: 'YT',
    },
    {
        name: 'Mexico',
        code: 'MX',
    },
    {
        name: 'Micronesia, Federated States of',
        code: 'FM',
    },
    {
        name: 'Moldova, Republic of',
        code: 'MD',
    },
    {
        name: 'Monaco',
        code: 'MC',
    },
    {
        name: 'Mongolia',
        code: 'MN',
    },
    {
        name: 'Montserrat',
        code: 'MS',
    },
    {
        name: 'Morocco',
        code: 'MA',
    },
    {
        name: 'Mozambique',
        code: 'MZ',
    },
    {
        name: 'Myanmar',
        code: 'MM',
    },
    {
        name: 'Namibia',
        code: 'NA',
    },
    {
        name: 'Nauru',
        code: 'NR',
    },
    {
        name: 'Nepal',
        code: 'NP',
    },
    {
        name: 'Netherlands',
        code: 'NL',
    },
    {
        name: 'Netherlands Antilles',
        code: 'AN',
    },
    {
        name: 'New Caledonia',
        code: 'NC',
    },
    {
        name: 'New Zealand',
        code: 'NZ',
    },
    {
        name: 'Nicaragua',
        code: 'NI',
    },
    {
        name: 'Niger',
        code: 'NE',
    },
    {
        name: 'Nigeria',
        code: 'NG',
    },
    {
        name: 'Niue',
        code: 'NU',
    },
    {
        name: 'Norfolk Island',
        code: 'NF',
    },
    {
        name: 'Northern Mariana Islands',
        code: 'MP',
    },
    {
        name: 'Norway',
        code: 'NO',
    },
    {
        name: 'Oman',
        code: 'OM',
    },
    {
        name: 'Pakistan',
        code: 'PK',
    },
    {
        name: 'Palau',
        code: 'PW',
    },
    {
        name: 'Palestinian Territory, Occupied',
        code: 'PS',
    },
    {
        name: 'Panama',
        code: 'PA',
    },
    {
        name: 'Papua New Guinea',
        code: 'PG',
    },
    {
        name: 'Paraguay',
        code: 'PY',
    },
    {
        name: 'Peru',
        code: 'PE',
    },
    {
        name: 'Philippines',
        code: 'PH',
    },
    {
        name: 'Pitcairn',
        code: 'PN',
    },
    {
        name: 'Poland',
        code: 'PL',
    },
    {
        name: 'Portugal',
        code: 'PT',
    },
    {
        name: 'Puerto Rico',
        code: 'PR',
    },
    {
        name: 'Qatar',
        code: 'QA',
    },
    {
        name: 'Reunion',
        code: 'RE',
    },
    {
        name: 'Romania',
        code: 'RO',
    },
    {
        name: 'Russian Federation',
        code: 'RU',
    },
    {
        name: 'RWANDA',
        code: 'RW',
    },
    {
        name: 'Saint Helena',
        code: 'SH',
    },
    {
        name: 'Saint Kitts and Nevis',
        code: 'KN',
    },
    {
        name: 'Saint Lucia',
        code: 'LC',
    },
    {
        name: 'Saint Pierre and Miquelon',
        code: 'PM',
    },
    {
        name: 'Saint Vincent and the Grenadines',
        code: 'VC',
    },
    {
        name: 'Samoa',
        code: 'WS',
    },
    {
        name: 'San Marino',
        code: 'SM',
    },
    {
        name: 'Sao Tome and Principe',
        code: 'ST',
    },
    {
        name: 'Saudi Arabia',
        code: 'SA',
    },
    {
        name: 'Senegal',
        code: 'SN',
    },
    {
        name: 'Serbia and Montenegro',
        code: 'CS',
    },
    {
        name: 'Seychelles',
        code: 'SC',
    },
    {
        name: 'Sierra Leone',
        code: 'SL',
    },
    {
        name: 'Singapore',
        code: 'SG',
    },
    {
        name: 'Slovakia',
        code: 'SK',
    },
    {
        name: 'Slovenia',
        code: 'SI',
    },
    {
        name: 'Solomon Islands',
        code: 'SB',
    },
    {
        name: 'Somalia',
        code: 'SO',
    },
    {
        name: 'South Africa',
        code: 'ZA',
    },
    {
        name: 'South Georgia and the South Sandwich Islands',
        code: 'GS',
    },
    {
        name: 'Spain',
        code: 'ES',
    },
    {
        name: 'Sri Lanka',
        code: 'LK',
    },
    {
        name: 'Sudan',
        code: 'SD',
    },
    {
        name: 'Suriname',
        code: 'SR',
    },
    {
        name: 'Svalbard and Jan Mayen',
        code: 'SJ',
    },
    {
        name: 'Swaziland',
        code: 'SZ',
    },
    {
        name: 'Sweden',
        code: 'SE',
    },
    {
        name: 'Switzerland',
        code: 'CH',
    },
    {
        name: 'Syrian Arab Republic',
        code: 'SY',
    },
    {
        name: 'Taiwan, Province of China',
        code: 'TW',
    },
    {
        name: 'Tajikistan',
        code: 'TJ',
    },
    {
        name: 'Tanzania, United Republic of',
        code: 'TZ',
    },
    {
        name: 'Thailand',
        code: 'TH',
    },
    {
        name: 'Timor-Leste',
        code: 'TL',
    },
    {
        name: 'Togo',
        code: 'TG',
    },
    {
        name: 'Tokelau',
        code: 'TK',
    },
    {
        name: 'Tonga',
        code: 'TO',
    },
    {
        name: 'Trinidad and Tobago',
        code: 'TT',
    },
    {
        name: 'Tunisia',
        code: 'TN',
    },
    {
        name: 'Turkey',
        code: 'TR',
    },
    {
        name: 'Turkmenistan',
        code: 'TM',
    },
    {
        name: 'Turks and Caicos Islands',
        code: 'TC',
    },
    {
        name: 'Tuvalu',
        code: 'TV',
    },
    {
        name: 'Uganda',
        code: 'UG',
    },
    {
        name: 'Ukraine',
        code: 'UA',
    },
    {
        name: 'United Arab Emirates',
        code: 'AE',
    },
    {
        name: 'United Kingdom',
        code: 'GB',
    },
    {
        name: 'United States',
        code: 'US',
    },
    {
        name: 'United States Minor Outlying Islands',
        code: 'UM',
    },
    {
        name: 'Uruguay',
        code: 'UY',
    },
    {
        name: 'Uzbekistan',
        code: 'UZ',
    },
    {
        name: 'Vanuatu',
        code: 'VU',
    },
    {
        name: 'Venezuela',
        code: 'VE',
    },
    {
        name: 'Viet Nam',
        code: 'VN',
    },
    {
        name: 'Virgin Islands, British',
        code: 'VG',
    },
    {
        name: 'Virgin Islands, U.S.',
        code: 'VI',
    },
    {
        name: 'Wallis and Futuna',
        code: 'WF',
    },
    {
        name: 'Western Sahara',
        code: 'EH',
    },
    {
        name: 'Yemen',
        code: 'YE',
    },
    {
        name: 'Zambia',
        code: 'ZM',
    },
    {
        name: 'Zimbabwe',
        code: 'ZW',
    },
];

export const ADD_ON_AUTHENTICATION_TYPE = {
    API_KEY: 'api_key',
    USERNAME_PASSWORD: 'username_password',
    OAUTH2_AUTHORIZATION_CODE: 'oauth2_authorization_code',
};

export const ADD_ON_CONFIGURATION = [
    {
        value: ADD_ON_AUTHENTICATION_TYPE.API_KEY,
        name: 'API Key',
    },
    {
        value: ADD_ON_AUTHENTICATION_TYPE.USERNAME_PASSWORD,
        name: 'Username and Password',
    },
    {
        value: ADD_ON_AUTHENTICATION_TYPE.OAUTH2_AUTHORIZATION_CODE,
        name: 'OAuth Authorization Code',
    },
];

export const SAMPLING_FILTER_OPTIONS = [
    {
        value: '1d',
        name: 'daily',
    },
    {
        value: '1w',
        name: 'weekly',
    },
    {
        value: '1M',
        name: 'monthly',
    },
];

export const ID_TYPE_VISITOR_ID = 'visitorId';

export const ID_TYPE_OPTIONS = [
    { value: ID_TYPE_VISITOR_ID, name: 'Visitor ID' },
    { value: 'userId', name: 'User ID' },
];

export const DAY_SPLIT = 'daySplit';
export const BREAK_SPLIT = 'breakSplit';
export const SEQUENCE_SPLIT = 'sequenceSplit';
export const CUSTOM_PRESET = 'customPreset';

export const SEQUENCE_MINER_DAY_SESSIONS = 'SequenceMinerDaySessions';
export const SEQUENCE_MINER_SESSIONS = 'SequenceMinerSessions';
export const SEQUENCE_MINER_TIME_SESSIONS = 'SequenceMinerTimeSessions';
export const SEQUENCE_MINER = 'SequenceMiner';
export const SEQUENCE_MINER_DERIVED_TIME_SESSIONS = 'SequenceMinerDerivedTimeSessions';
export const SEQUENCE_MINER_DERIVED_SESSIONS = 'SequenceMinerDerivedSessions';

export const PRESETS_OPTIONS = [
    { value: DAY_SPLIT, name: 'Day split' },
    { value: BREAK_SPLIT, name: 'Activity Break split' },
    { value: SEQUENCE_SPLIT, name: 'Sequence split' },
    { value: CUSTOM_PRESET, name: 'Custom values' },
];

export const SEQUENCE_MINER_OPTIONS = [
    { value: SEQUENCE_MINER, name: 'Conversation activity split' },
    { value: SEQUENCE_MINER_SESSIONS, name: 'Activity Break split' },
    { value: SEQUENCE_MINER_DERIVED_SESSIONS, name: 'Activity derived break split' },
    { value: SEQUENCE_MINER_TIME_SESSIONS, name: 'Activity sequence split' },
    { value: SEQUENCE_MINER_DERIVED_TIME_SESSIONS, name: 'Activity derived sequence split' },
];

export const MODEL_TYPE_WORKDAY = 'workday';
export const MODEL_SIMILARITY_BASED = 'similarityBased';
export const MODEL_CUSTOMER_SERVICE = 'customerService';
export const MODEL_FINANCE_AND_OPERATIONS = 'financeAndOperations';
export const MODEL_SALESFORCE = 'salesforce';
export const MODEL_SAP_CONCUR = 'sapConcur';

export const MODEL_TYPE_OPTIONS = [
    { value: MODEL_TYPE_WORKDAY, name: 'Workday' },
    { value: MODEL_CUSTOMER_SERVICE, name: 'MS Customer Service' },
    { value: MODEL_FINANCE_AND_OPERATIONS, name: 'MS Finance and Operations' },
    { value: MODEL_SALESFORCE, name: 'Salesforce' },
    { value: MODEL_SAP_CONCUR, name: 'SAP Concur' },
    { value: MODEL_SIMILARITY_BASED, name: 'Similarity based' },
];
